import { mockProcessResult } from './responseResult';

const withAuthCheck = (resolver) => {
  return async (req, res, ctx) => {
    const request = req;
    const transId = request.headers.get('transId');

    if (!transId) {
      return res(
        ctx.json(
          mockProcessResult(
            {
              message: 'transId is required',
            },
            false
          )
        )
      );
    }

    return resolver(req, res, ctx);
  };
};

const withScenario = (resolver) => {
  // URL 參數對應的覆蓋設定
  // 範例：http://localhost:3001/index?scenario=error&delay=3000&override=apiEndpoint
  return async (req, res, ctx) => {
    const request = req;

    try {
      const search = typeof window !== 'undefined' ? window.location.search : ''; // 在 Node.js 環境下預設為空字串
      const scenario = new URLSearchParams(search).get('scenario');
      const delayMs = new URLSearchParams(search).get('delay');
      const override = new URLSearchParams(search).get('override');

      let shouldHandleScenario = false;
      let shouldDelay = Boolean(delayMs);

      if (override) {
        const regex = new RegExp(`(^|/)${override}(/|$)`);
        const isMatched = regex.test(new URL(request.url).pathname);
        shouldHandleScenario = isMatched;
        shouldDelay = isMatched && Boolean(delayMs);
      }

      if (shouldDelay && delayMs) {
        await new Promise((r) => setTimeout(r, Number(delayMs)));
      }

      if (shouldHandleScenario && scenario) {
        switch (scenario) {
          case 'httpError':
            return res(ctx.status(500));

          case 'error':
            return res(ctx.json(mockProcessResult(null, false)));

          case 'empty':
            return res(ctx.body(''));

          default:
            break;
        }
      }

      return resolver(req, res, ctx, Number(delayMs));
    } catch (error) {
      console.log(error);
    }
  };
};

export { withAuthCheck, withScenario };
